import { render, staticRenderFns } from "./OverviewStationTACGrowthQuantityByRegion.vue?vue&type=template&id=566513b4"
import script from "./OverviewStationTACGrowthQuantityByRegion.vue?vue&type=script&lang=js"
export * from "./OverviewStationTACGrowthQuantityByRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports